module.exports = __webpack_public_path__ + "static/media/super-essencial.dabc63fd.svg";